export const propagateError = (error: Error) => {
    setTimeout(() => {
        throw error;
    }, 0);
};
